import * as React from "react";
import Grid from "@mui/material/Grid";
import MailIcon from "@mui/icons-material/Mail";
import {
  Alert,
  Autocomplete,
  Badge,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  TextareaAutosize as BaseTextareaAutosize,
  Tooltip,
  autocompleteClasses,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import WarningIcon from "@mui/icons-material/Warning";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { AppraisalValueTable } from "./AppraisalValues";
import { AppraisalAssetsList } from "./AppraisalAssetList";
import {
  AppraisalReviewServiceURL,
  DocumentServiceURL,
  InvestmentServiceURL,
  LookupServieURL,
  TaskmgmtServiceURL,
} from "../../../config/config";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { constants } from "buffer";
import { ServiceName } from "../../../constants";
import { useEffect, useState } from "react";
import { ViewTabList } from "../documents/ViewTabList";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import selectedInvestmentForAppraisalslice, {
  InvestmentNames,
  updateSelectedInvestmentForAppraisal,
} from "../../../redux/slices/selectedInvestmentForAppraisalslice";
import {
  UserContext,
  updateUserContext,
} from "../../../redux/slices/userContextSlice";
import axios, { AxiosResponse } from "axios";
import { wait } from "@testing-library/user-event/dist/utils";
import {
  AllCountriesModel,
  ApplicationUser,
  AppraisalAssetsModel,
  AppraisalsDetailsModelForEquity,
  DocumentTypesModel,
  ExternalAppraisersModel,
  InvestmentIDsModel,
  InvestmentForAppraisalModel,
  UserRoleMapModel,
  AppraisalDetailsModelForCM,
  AppraisalAttachment,
  UploadPreSignedPayloadModel,
  AppraisalDetailsModelForDLorDA,
  AppraisalModel,
  Appraisal,
  AuditLog,
  GetAppraisalModel,
  AppraisalTask,
  AppraisalRevokedRequest,
  FileChunk,
} from "../../../all_Interfaces";
import { AlertDialog } from "../../util/Dialog";
import AppraisalDetailsForUSAppraisal, {
  updateAppraisalDetailsForUSAppraisal,
} from "../../../redux/slices/AppraisalDetailsForUSAppraisalSlice";
import { addAuditLogs } from "../../../redux/slices/AuditSlice";
import { updateAppraisalAssets } from "../../../redux/slices/AppraisalAssetsSlice";
import { AppraisalValuesForCM } from "./AppraisalValuesForCM";
import { AppraisalValueTableForDLorDA } from "./AppraisalValuesDLorDA";
import { updateAppraisalDetailsForCM } from "../../../redux/slices/AppraisalDetailsForCMSlice";
import { updateAppraisalDetailsForDLorDA } from "../../../redux/slices/AppraisalDetailsForDLorDASlice";
import { DebtAssetsAssetList } from "./DebtAssetsAssetList";
import { ToastMessage } from "../../util/ToastMessage";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { useNavigate, useParams } from "react-router-dom";
import UpdateExistingAttachmentSlice, {
  updateAttachments,
} from "../../../redux/slices/UpdateExistingAttachmentSlice";
import { updateappraisalSubmitEvent } from "../../../redux/slices/AppraisalSubmitEventSlice";
import { LiveTv } from "@mui/icons-material";
import { updateFlagToDisableControlesForAppraisal } from "../../../redux/slices/DisableAppraisalControlsSlice";
import { HamburgerMenu } from "./HamburgerMenu";
import { HorizontalStepper } from "../../util/Steper";
import AuditButton from "../Audit/auditButton";

const TextareaAutosize = styled(BaseTextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${
      theme.palette.mode === "dark" ? grey[900] : grey[50]
    };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${
        theme.palette.mode === "dark" ? blue[600] : blue[200]
      };
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const TextareaAutosizee = styled(TextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${
      theme.palette.mode === "dark" ? grey[900] : grey[50]
    };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${
        theme.palette.mode === "dark" ? blue[600] : blue[200]
      };
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);
const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const DebtLiabilityAppraisalFormEdit = (props: any) => {
  const params = useParams();
  const page = "edit";
  const appraisalId = params.appraisalId;
  const pathnames = window.location.pathname.split("/").filter((x) => x);
  const [openRevokeDialog, setOpenRevokeDialog] = useState<boolean>(false);
  const [revokeComments, setRevokeComments] = useState("");
  const [openModel, setOpenModel] = useState<{
    isOpen: boolean;
    message: string;
  }>({ isOpen: false, message: "" });
  console.log(window.location.pathname);
  const [assetManagerInvalid, setAssetManagerInvalid] = useState<{
    flag: boolean;
    message: string;
  }>({ flag: false, message: "" });
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [workflowSteps, setWorkflowSteps] = useState<string[]>([]);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [appraisalDataAfterSave, setAppraisalDataAfterSave] = useState<{
    appraisalId: string;
    xmin: number;
  }>({ appraisalId: "", xmin: 0 });
  const [postEditComments,setPostEditComments] = useState<string>("");
  const [openPostEdit, setOpenPostEdit] = useState(false); 
  const [documentTypes, setDocumentTypes] = useState<DocumentTypesModel[]>([]);
  const [isSaveClicked, setIsSaveClicked] = useState<boolean>(false);
  const [frequency, setFrequency] = useState<string>("");
  const [appraisalType, setAppraisalType] = useState<string>("");
  const fileSize = React.useRef<any>();
  const chunkSize = React.useRef<number>(1048576 * 3);
  const fileToBeUpload = React.useRef<any>();
  const chunkCount = React.useRef<any>();
  const chunk = React.useRef<any>();
  const fileGuid = React.useRef<any>();
  const counter = React.useRef<number>(1);
  const beginingOfTheChunk = React.useRef<number>(0);
  const endOfTheChunk = React.useRef<any>();
  const uploadStartResponse = React.useRef<any>();
  const largeFileCount = React.useRef<number>(0);

  const largeFileSuccessCount = React.useRef<number>(0);
  const largeFileFailedCount = React.useRef<number>(0);
  const [selectedExternalAppraiser, setSelectedExternalAppraiser] =
    useState<string>("");
  const [appraisalsDetailsRDX, setAppraisalDetailsRDX] =
    useState<AppraisalsDetailsModelForEquity>({
      currentAppraisalValue: 0,
      effectiveDateOfValue: "",
      sheduled_n_cost: 0,
      lastAppraisedValue: 0,
      lastAppraisalPercentageChange: 0,
      lastAppraisedDate: "",
      lastAnnualAppraisedValue: 0,
      lastAnnualAppraisalPercentageChange: 0,
      lastAnnualAppraisedDate: "",
      currencySelected: "",
      GPAppraisalValue:0
    });
    const [fileMessage, setFileMessage] = useState<boolean>(false);

  const [appraisalDetailsForCMRDX, setAppraisalDetailsForCMRDX] =
    useState<AppraisalDetailsModelForCM>({
      currencySelected: "",
      propertyValueAsIs: 0,
      propertyValueAsIsDate: "",
      capRateAsIs: 0,
      propertyValueStabilized: 0,
      propertyValueStabilizedDate: "",
      capRateStabilized: 0,
      propertyInsurableValue: 0,
      propertyLandValue: 0,
      reportDate: "",
    });
  const [appraisalDetailsForDLorDARDX, setAppraisalDetailsForDLorDARDX] =
    useState<AppraisalDetailsModelForDLorDA>({
      currencySelected: "",
      currentDebtValue: 0,
      currentPrincipalValue: 0,
      loanToValueRatio: 0,
      treasuryRate: 0,
      riskPremium: 0,
      surveyYield: 0,
      currentEffectiveDate: "",
      derivative: 0,
      lastDebtValue: 0,
      lastDebtPercentageChange: 0,
      lastDebtEffectiveDate: "",
    });

  const [externalAppraiserArray, setExternalAppraiserArray] = useState<
    string[]
  >([]);
  const [selectedAppraisalFirm, setSelectedAppraisalFirm] = useState<{
    label: string;
    value: string;
  }>({ label: "", value: "" });
  const appraisalTypeArray: string[] = ["1A",
    "1Q1A",
    "1Q2A",
    "1Q3A",
    "2A",
    "2Q1A",
    "2Q2A",
    "2Q3A",
    "3A",
    "3Q1A",
    "3Q2A",
    "3Q3A",
    "CM",
    "DA",
    "DL",
    "DL Interim",
    "I",
    "SA1A",
    "SA2A",
    "SA3A"];

  const [loading, setLoading] = useState<boolean>(false);
  const [oldSelectedInvestment, setOldSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);
  const [newSelectedInvestment, setNewSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);

  const [firstLoadResults, setFirstLoadResults] = useState<{
    fundsUsersByUser: UserRoleMapModel[];
    allDocumentTypes: DocumentTypesModel[];
    allCountries: AllCountriesModel[];
    allExternalAppraisers: ExternalAppraisersModel[];
    appraisalData: GetAppraisalModel;
    auditData: AuditLog[];
  }>({
    fundsUsersByUser: [] as UserRoleMapModel[],
    allDocumentTypes: [] as DocumentTypesModel[],
    allCountries: [] as AllCountriesModel[],
    allExternalAppraisers: [] as ExternalAppraisersModel[],
    appraisalData: {} as GetAppraisalModel,
    auditData: [] as AuditLog[],
  });
  const [investmentIdAndType, setInvestmentIdAndType] = useState<{
    investmentId: string;
    investmentType: string;
  }>({ investmentId: "", investmentType: "" });

  const [latestPendingAppraisal, setLatestPendingAppraisal] =
    useState<GetAppraisalModel>(new GetAppraisalModel());
  const [isPendingAppraisal, setIsPendingAppraisal] = useState<boolean>(false);
  const [allDocTypes, setAllDocTypes] = useState<DocumentTypesModel[]>([]);
  // const [isMortgage, setIsMortgage] = useState<boolean>(false);
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  let isMortgage: boolean = false;
  const [appraisalFirms, setAppraisalFirms] = useState<
    { label: string; value: string }[]
  >([]);
  const [appraiser1List, setAppraiser1List] = useState<
    {
      firstName: string;
      lastName: string;
      email: string;
      name: string;
      userType: string;
    }[]
  >([]);
  const [selectedInvestment, setSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [attachments, setAttachments] = useState<AppraisalAttachment[]>([]);
  const [modifiedAsset, setModifiedAsset] = useState<AppraisalAssetsModel[]>(
    []
  );
  const [InvestmentIdAndAppraisalId, setInvestmentIdAndAppraisalId] = useState<{
    investmentId: string;
    appraisalId: string;
  }>({ investmentId: "", appraisalId: "" });
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const userContext: UserContext = useAppSelector(
    (state) => state.UserContext.data
  );
  const [
    flagToDisableControlesForAppraisal,
    setFlagToDisableControlesForAppraisal,
  ] = useState<boolean>(false); //</boolean>: boolean = useAppSelector(state => state.UpdateFlagToDisableControlesForAppraisal.data);
  const [appraisalTypeEditFlag, setAppraisalTypeEditFlag] = useState<boolean>(false);
  const [appraisalTypeEditClicked,setAppraisalTypeEditClicked] = useState<boolean>(false);
  const [ selectedAppraisalType, setSelectedAppraisalType] = useState<string>("");
  const [appraisalTypeEditable, setAppraisalTypeEditable] = useState<boolean>(false);
  const allCountries = React.useRef<AllCountriesModel[]>([]);
  const appraisalDetails: AppraisalsDetailsModelForEquity = useAppSelector(
    (state) => state.AppraisalDetailsForUSAppraisal.data
  );
  const appraisalDetailsForCM: AppraisalDetailsModelForCM = useAppSelector(
    (state) => state.AppraisalDetailsForCM.data
  );

  const appraisalDetailsForDLorDA: AppraisalDetailsModelForDLorDA =
    useAppSelector((state) => state.AppraisalDetailsForDLorDA.data);

  const NewAttachmentList: AppraisalAttachment[] = useAppSelector(
    (state) => state.AddNewAttachments.data
  );

  const latestSelectedInvestment: InvestmentForAppraisalModel = useAppSelector(
    (state) => state.SelectedInvestmentForAppraisal.data
  );
  const modifiedAssets: AppraisalAssetsModel[] = useAppSelector(
    (state) => state.AppraisalAssets.data
  );
  // const selectedInvestment = useAppSelector(
  //   (state) => state.SelectedInvestmentForAppraisal?.data
  // );
  const [cityStateCountry, setCityStateCountry] = useState<string>("");
  const [selectedAppraiser1, setSelectedAppraiser1] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    name: string;
    userType: string;
  } | null>({
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    userType: "",
  });

  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const selectRef = React.useRef<any>(null);
  useEffect(() => {
    if( appraisalTypeEditable && selectRef.current){
     selectRef.current.focus();
    }
     
   }, [appraisalTypeEditable]);
  useEffect(() => {
    setModifiedAsset(modifiedAssets);
    console.log(modifiedAssets);
  }, [modifiedAssets]);

  useEffect(() => {
    setAttachments(NewAttachmentList);
    console.log(NewAttachmentList);
  }, [NewAttachmentList]);

  useEffect(() => {
    setAppraisalDetailsRDX(appraisalDetails);
  }, [appraisalDetails]);

  useEffect(() => {
    setAppraisalDetailsForCMRDX(appraisalDetailsForCM);
  }, [appraisalDetailsForCM]);

  useEffect(() => {
    setAppraisalDetailsForDLorDARDX(appraisalDetailsForDLorDA);
    console.log(appraisalDetailsForDLorDA);
  }, [appraisalDetailsForDLorDA]);

  // useEffect(() => {
  //   if (Object.keys(userContext).length == 0) {
  //     getProfile(true).then((data: any) => {
  //       dispatch(updateUserContext(data));
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (userContext.isAdmin || userContext.isAppraisal1 || userContext.debtAppraiser1) {
      dispatch(updateAppraisalDetailsForUSAppraisal(new AppraisalsDetailsModelForEquity()));
        dispatch(updateAppraisalDetailsForCM(new AppraisalDetailsModelForCM()));
        dispatch(updateAppraisalDetailsForDLorDA(new AppraisalDetailsModelForDLorDA()));
        dispatch(updateAppraisalAssets([] as AppraisalAssetsModel[]));
      fetchAndPopulateData();
    } else {
      navigate("/unauthorized");
    }
  }, [userContext]);

  console.log(appraisalDetails);
  console.log(appraisalDetailsForCM);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const submitEvent: boolean = useAppSelector(
    (state) => state.AppraisalSubmitEvent.data
  );

  useEffect(() => {
    setIsSubmit(submitEvent);
    if (submitEvent && firstLoadResults.appraisalData.assetManager != null) {
      if (
        firstLoadResults.appraisalData.assetManager.email.toLowerCase() ==
        "not.applicable@maskedqicaait.org"
      ) {
        setAssetManagerInvalid({
          flag: true,
          message: "Asset Manager Email is not Valid",
        });
      }
    }
  }, [submitEvent]);

  const fetchAndPopulateData = async () => {
    dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
    try {
      setLoading(true);
      const [call2, call1, call3, call4, call5, call6, call7] =
        await Promise.all([
          getApiCall(
            AppraisalReviewServiceURL + "/appraisals/getbyid/" + appraisalId,
            ServiceName.APPRAISALREVIEW
          ).then((data: any) => {
            var d = data.result.appraisalType as string;
            if (!d.toLowerCase().includes("dl")) {
              navigate("/main/appraisal-form/" + page + "/" + appraisalId);
            }
            return data;
          }),
          getApiCall(
            TaskmgmtServiceURL +
              "/userrolemaps/GetFundsByUser?email=" +
              currentUserData.email?.toLowerCase(),
            ServiceName.TASKMANAGEMENTSERVICE
          ),
          getApiCall(
            LookupServieURL + "/DocumentTypes/GetAll",
            ServiceName.LOOKUPSERVICE
          ),
          getApiCall(
            LookupServieURL + "/DocumentTypes/GetAllCountries",
            ServiceName.LOOKUPSERVICE
          ),
          getApiCall(
            LookupServieURL + "/externalappraisers/getall",
            ServiceName.LOOKUPSERVICE
          ),
          getApiCall(
            TaskmgmtServiceURL + "/AuditTasks/GetByAppraisalId/" + appraisalId,
            ServiceName.TASKMANAGEMENTSERVICE
          ),
          getApiCall(
            DocumentServiceURL + "/Documents/getall/" + appraisalId,
            ServiceName.DOCUMENTSERVICE
          ),
        ]);
      const appraisalData: GetAppraisalModel = (call2 as any).result;
      if(appraisalData.appraisalType.toLowerCase() === 'dl'){
        setModifiedAsset([] as AppraisalAssetsModel[])
      }
      const loggs: AuditLog[] = [...(call6 as any).result];
      var formattedloggs: AuditLog[] = [];
      if (loggs.length != 0) {
        loggs.forEach((data: AuditLog) => {
          const date = new Date(data.created);
          const log: AuditLog = { ...data, created: date.toLocaleString() };
          formattedloggs.push(log);
        });
        
      }
      const startingLog:AuditLog = {
        id: "",
        appraisalId: "",
        status: "New",
        taskComments: "",
        approverName: "Created by "+appraisalData.createdBy,
        taskStatus: "",
        previousStatus: "",
        approverEmail: "",
        workflowId: "",
        xmin: 0,
        createdBy: "",
        created: appraisalData.created,
        lastModifiedBy: "",
        lastModified: ""
      }
      formattedloggs.push(startingLog);
      console.log("audit>>>>>>>",formattedloggs);
      dispatch(addAuditLogs(formattedloggs));

      var docArray: DocumentTypesModel[] = [...(call3 as any).result];
      const attcahments: AppraisalAttachment[] = [...(call7 as any)];

      var formattedAttachments: AppraisalAttachment[] = [];
      if (attcahments.length != 0) {
        attcahments.forEach((data: AppraisalAttachment) => {
          const date = new Date(data.lastModifiedDate);
          const doc: AppraisalAttachment = {
            ...data,
            lastModifiedDate: date.toLocaleString(),
          };
          formattedAttachments.push(doc);
        });
      }
      dispatch(updateAttachments(formattedAttachments));
      // docArray.push({id:0,
      //   name:"All",
      //   tag:"string",
      //   appraisalCycle:"string",
      //   investmentType:"string",
      //   sortOrder:0,
      //   region:"string"});

      const allDocTypes: DocumentTypesModel[] = docArray.sort(
        (a: any, b: any) => (a.id > b.id ? 1 : -1)
      );

      try {
        await getApiCall(
          TaskmgmtServiceURL +
          "/FundConfigurations/GetFundConfigurationByFundIdAndInvestmentType?strFundId=" +
          appraisalData.fundId +
          "&strInvestmentType=" +
          appraisalData.investmentType,
          ServiceName.TASKMANAGEMENTSERVICE
        ).then((data: any) => {
          setFrequency(data?.result.appraisalSchedule || "");
        });
      } catch (error) {
        console.error("Error fetching fund config:", error);
      }

      setFirstLoadResults({
        fundsUsersByUser: (call1 as any).result,
        appraisalData: appraisalData,
        allDocumentTypes: allDocTypes,
        allCountries: (call4 as any).result,
        allExternalAppraisers: (call5 as any).result,
        auditData: (call6 as any).result,
      });
      allCountries.current = (call4 as any).result;
      setInvestmentIdAndAppraisalId({
        investmentId: appraisalData.investmentId,
        appraisalId: appraisalData.appraisalId,
      });
      var allExternalAppraisers = (call5 as any).result;
      setAllDocTypes(allDocTypes);

      if (
        appraisalData.investmentType.toLowerCase() === "mortgage" ||
        appraisalData.investmentType.toLowerCase() === "equity"
      ) {
        var tempDocTypes: DocumentTypesModel[] = [...allDocTypes];
        setDocumentTypes(
          tempDocTypes.filter(
            (doc: DocumentTypesModel) => doc.name !== "Debt Record"
          )
        );
      } else {
        setDocumentTypes(allDocTypes);
      }

      let tempAppraiser1: {
        firstName: string;
        lastName: string;
        email: string;
        name: string;
        userType: string;
      }[] = [];
      let arrTempAppraiser1Email: string[] = [];
      const appFund: string = appraisalData.fundId;

      if (userContext.isAdmin) {
        (call1 as any).result.forEach((user: UserRoleMapModel) => {
          const email = user.email.toLowerCase();
          if (user.email && arrTempAppraiser1Email.indexOf(email) == -1) {
            arrTempAppraiser1Email.push(email);
            tempAppraiser1.push({
              firstName: user.firstName,
              lastName: user.lastName,
              name: user.firstName + " " + user.lastName,
              email: email,
              userType: user.userType,
            });
          }
        });
      } else {
        (call1 as any).result.forEach((user: UserRoleMapModel) => {
          let arrCurrentFund = user.fundId.split(";");
          if (arrCurrentFund.indexOf(appFund) >= 0 && user.email) {
            const email = user.email.toLowerCase();
            if (user.email && arrTempAppraiser1Email.indexOf(email) == -1) {
              arrTempAppraiser1Email.push(email);
              tempAppraiser1.push({
                firstName: user.firstName,
                lastName: user.lastName,
                name: user.firstName + " " + user.lastName,
                email: email,
                userType: user.userType,
              });
            }
          }
        });
      }

      setAppraiser1List(
        tempAppraiser1
          .sort((a: any, b: any) => (a.firstName > b.firstName ? 1 : -1))
          .slice()
      );
      let currentUserIndex: number = tempAppraiser1.findIndex(
        (x) => x.email === userContext.email.toLowerCase()
      );

      if (appraisalData.appraiser1 != null) {
        var savedAppraiser1 =
          tempAppraiser1[
            tempAppraiser1.findIndex(
              (x) => x.email === appraisalData.appraiser1.email
            )
          ];
        if (savedAppraiser1 != undefined || savedAppraiser1 != null) {
          setSelectedAppraiser1(savedAppraiser1);
        } else {
          setSelectedAppraiser1(null);
        }
      } else {
        setSelectedAppraiser1(tempAppraiser1[currentUserIndex]);
      }
      //filtering the firms for firm autocomplete options
      let firmsArray: string[] = (call5 as any).result
        .map((d: ExternalAppraisersModel) => d.appraisalFirm)
        .filter(function (elem: any, index: any, self: string | any[]) {
          return index === self.indexOf(elem);
        })
        .filter((item: any) => item !== null);

      var tempFirmsArray: { label: string; value: string }[] = firmsArray
        .map((a) => {
          return { label: a, value: a };
        })
        .sort((a: any, b: any) => {
          if (b.value == null) return 1;
          return a.label > b.label ? 1 : -1;
        })
        .slice();

      setAppraisalFirms(tempFirmsArray);
      var firm: string = appraisalData.appraiserFirm;
      setSelectedAppraisalFirm({ label: firm, value: firm });

      var ExternalUsers: string[] = [];
      allExternalAppraisers.forEach(
        (appraiser: ExternalAppraisersModel) => {
          if (appraiser.appraisalFirm === firm) {
            ExternalUsers.push(appraiser.name);
          }
        }
      );
      populateDisplayForm(appraisalData, allDocTypes);
      const appraisalStatus: string = appraisalData.status.toLowerCase();
      const selectedInvestmentObj: InvestmentForAppraisalModel =
        new InvestmentForAppraisalModel();
      selectedInvestmentObj.investmentId = appraisalData.investmentId;
      selectedInvestmentObj.investmentType = appraisalData.investmentType;
      selectedInvestmentObj.name = appraisalData.investmentName;
      selectedInvestmentObj.fund = appraisalData.fund;
      selectedInvestmentObj.fundId = appraisalData.fundId;
      dispatch(updateSelectedInvestmentForAppraisal(selectedInvestmentObj));

      setExternalAppraiserArray([...ExternalUsers]);
      if (appraisalStatus === "new" || appraisalStatus.indexOf("reject") > -1 || appraisalStatus === "revoked" ) {
        fetchDataFromInvestment(appraisalData.investmentId, appraisalData);
      }
      if (
        //appraisalStatus.toLowerCase() != "posted" &&
        appraisalStatus.toLowerCase() != "new" &&
        appraisalStatus.toLowerCase() != "revoked" &&
        appraisalStatus.toLowerCase().indexOf("rejected") == -1
      ) {
        setFlagToDisableControlesForAppraisal(true);
      }
      if ( userContext.isAdmin &&
        appraisalStatus.toLowerCase() != "posted" &&
        (appraisalStatus.toLowerCase() == "new" ||
        appraisalStatus.toLowerCase() == "revoked" || appraisalStatus.toLowerCase().indexOf("pending") == -1) 
      ) {
        setAppraisalTypeEditFlag(true);
      }
      if (userContext.isAdmin &&
        appraisalStatus.toLowerCase() == "posted" ) {
        setAppraisalTypeEditFlag(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataFromInvestment = async (
    investmentId: string,
    appraisalData: GetAppraisalModel
  ) => {
    try {
      await getApiCall(
        InvestmentServiceURL +
          "/investments/GetByIdWithActiveAssets?id=" +
          investmentId,
        ServiceName.INVESTMENTSERVICE
      ).then((data: any) => {
        var investmentDetailsFromInvservice: InvestmentForAppraisalModel =
          data?.result;
        populateFieldBasedOnInvestment(
          investmentDetailsFromInvservice,
          appraisalData
        );
      });
    } catch (e) {
      console.log(e);
    }
  };

  const populateFieldBasedOnInvestment = (
    investmentDetailsFromInvservice: InvestmentForAppraisalModel,
    appraisalData: GetAppraisalModel
  ) => {
    console.log(investmentDetailsFromInvservice);
    var lastAppraisedValue =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastDLAppraisedValue === null
        ? 0
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastDLAppraisedValue;
    var lastAnnualAppraisedValue =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAnnualAppraisedValue === null
        ? 0
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastAnnualAppraisedValue;

    let cityStateCountry: string = "";
    cityStateCountry =
      investmentDetailsFromInvservice.city != undefined &&
      investmentDetailsFromInvservice.city != ""
        ? investmentDetailsFromInvservice.city
        : cityStateCountry;

    cityStateCountry =
      investmentDetailsFromInvservice.state != undefined &&
      investmentDetailsFromInvservice.state != ""
        ? cityStateCountry + ", " + investmentDetailsFromInvservice.state
        : cityStateCountry;

    cityStateCountry =
      isMortgage &&
      investmentDetailsFromInvservice.country != undefined &&
      investmentDetailsFromInvservice.country != ""
        ? cityStateCountry + ", " + investmentDetailsFromInvservice.country
        : cityStateCountry;
    // this.fgAppraisalForm.get("isInvestmentHasDebtLiability").setValue(this.isNewDL ? false : objInvestment.hasDebtLiability);

    var lastDebtAppraisedDate =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAppraisalDate === "" ||
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastDLAppraisalDate == null
        ? ""
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastDLAppraisalDate;
    var lastAnnualAppraisedDate =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAnnualAppraisalDate === "" ||
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastAnnualAppraisalDate == null
        ? ""
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastAnnualAppraisalDate;

    dispatch(
      updateAppraisalDetailsForDLorDA({
        currencySelected: appraisalData.currency,
        currentDebtValue: appraisalData.currentAppraisalValue,
        currentPrincipalValue: appraisalData.currentPrincipalValue,
        loanToValueRatio: appraisalData.loanToValueRatio,
        treasuryRate: appraisalData.treasuryRate,
        riskPremium: appraisalData.riskPremium,
        surveyYield: appraisalData.surveyYield,
        currentEffectiveDate: appraisalData.valueDate,
        derivative: appraisalData.derivative,
        lastDebtValue:lastAppraisedValue,
        lastDebtPercentageChange:
          appraisalData.currentAppraisalValue != null &&
          investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastDLAppraisedValue !== null
            ? percentageChange(
                appraisalData.currentAppraisalValue,
                investmentDetailsFromInvservice.fgInvestmentAppraisalValues
                  .lastDLAppraisedValue
              )
            : 0,
        lastDebtEffectiveDate:lastDebtAppraisedDate,
      })
    );
  };

  const percentageChange = (curr: number, last: number) => {
    const change = (((curr - last) / last) * 100).toFixed(2);
    return change;
  };

  const populateDisplayForm = (
    appraisalData: GetAppraisalModel,
    allDocumentTypes: DocumentTypesModel[]
  ) => {
    let cityStateCountry: string = "";
    cityStateCountry =
      appraisalData.city != undefined && appraisalData.city != ""
        ? appraisalData.city
        : cityStateCountry;

    cityStateCountry =
      appraisalData.state != undefined && appraisalData.state != ""
        ? cityStateCountry + ", " + appraisalData.state
        : cityStateCountry;

    cityStateCountry =
      isMortgage &&
      appraisalData.country != undefined &&
      appraisalData.country != ""
        ? cityStateCountry + ", " + appraisalData.country
        : cityStateCountry;
    setCityStateCountry(cityStateCountry);
    setAppraisalType(appraisalData.appraisalType);
    CanSubmit(appraisalData);
    setSelectedExternalAppraiser(appraisalData.externalAppraiser);
    if((appraisalData.workflowSteps != undefined || appraisalData.workflowSteps != null) && appraisalData.workflowSteps != ""){
      setWorkflowSteps(JSON.parse(appraisalData.workflowSteps));
      }else{
      setWorkflowSteps([] as string[]);
  }
    setActiveIndex(appraisalData.activeIndex);

    dispatch(
      updateAppraisalDetailsForDLorDA({
        currencySelected: appraisalData.currency,
        currentDebtValue: appraisalData.currentAppraisalValue,
        currentPrincipalValue: appraisalData.currentPrincipalValue,
        loanToValueRatio: appraisalData.loanToValueRatio,
        treasuryRate: appraisalData.treasuryRate,
        riskPremium: appraisalData.riskPremium,
        surveyYield: appraisalData.surveyYield,
        currentEffectiveDate: appraisalData.valueDate,
        derivative: appraisalData.derivative,
        lastDebtValue: appraisalData.lastAppraisedValue,
        lastDebtPercentageChange: formatNumberTo0Decimal(appraisalData.percentageChange),
        lastDebtEffectiveDate: appraisalData.lastAppraisalDate,
      })
    );
  };

  const formatNumberTo0Decimal = (num: any) => {
    const regxmain = /^-?\d+(\.\d+)?$/;
    const regex1 = /^\d+\.\d{1}$/;
    const regx2 = /^\d+$/;
    const regx3 = /^-?\d+\.\d{1}$/; // tocheck - number
    if (regxmain.test(num)) {
      return num.toFixed(2);
    }
    // if (regex1.test(num)) {
    //   return num.toFixed(2);
    // }else  if(regx2.test(num)) {
    //   return num.toFixed(2);
    // }else if(regx3.test(num)){
    //   return `${num.toFixed(2)}`;
    // }
    return num;
  }
  console.log(firstLoadResults.appraisalData);

  const handleAppraiser1Change = (appraiser1: {
    firstName: string;
    lastName: string;
    email: string;
    name: string;
    userType: string;
  }) => {
    setSelectedAppraiser1(appraiser1);
  };

  const handleFirmChangeChange = (arselectedFirm: {
    label: string;
    value: string;
  }) => {
    setSelectedAppraisalFirm(arselectedFirm);
    var users: string[] = [];
    firstLoadResults.allExternalAppraisers.forEach(
      (appraiser: ExternalAppraisersModel) => {
        if (appraiser.appraisalFirm === arselectedFirm.value) {
          users.push(appraiser.name);
        }
      }
    );
    setExternalAppraiserArray(users);
  };

  const handleExternalAppraiserChange = (name: string) => {
    setSelectedExternalAppraiser(name);
  };

  const resetChunkProperties = () => {
    //setShowProgress(true);
    //setProgress(0);
    setCounter(1);
    beginingOfTheChunk.current = 0;
    endOfTheChunk.current = chunkSize.current;
  }

  const setCounter = (counterr: number) => {
    counter.current = counterr;
  }

  const submitAttachment = async (appraisalId: string,btnEvent:string) => {
    // attachments.forEach(async (file: AppraisalAttachment) => {
    //   var tempFilePayload = new UploadPreSignedPayloadModel();
    //   tempFilePayload.doctype = file.doctype;
    //   tempFilePayload.fileAsBase64 = file.fileAsBase64;
    //   tempFilePayload.fileName = file.fileName;
    //   tempFilePayload.fileSize = file.fileSize;
    //   tempFilePayload.fileType = file.fileType;
    //   tempFilePayload.guid = firstLoadResults.appraisalData.appraisalId;
    //   tempFilePayload.lastModifiedBy = file.lastModifiedBy;
    //   tempFilePayload.lastModifiedDate = file.lastModifiedDate;
    //   tempFilePayload.lastModifiedTime = file.lastModifiedTime;

    //   const key: string =
    //     firstLoadResults.appraisalData.appraisalId +
    //     "_" +
    //     file.doctype +
    //     "_" +
    //     file.fileName;

    //   const payload = { TggingKey: key, Attachement: tempFilePayload };
    //   setFileMessage(true);
    //   await postApiCall(
    //     DocumentServiceURL + "/Documents/GetUploadPreSignedURL",
    //     tempFilePayload,
    //     ServiceName.DOCUMENTSERVICE
    //   ).then(async (data) => {
    //     try {
    //       return await axios
    //         .put(data as string, file.file, {
    //           headers: {
    //             "Content-Type": file.fileType
    //           },
    //         })
    //         .then(async (data: any) => {
    //           return await postApiCall(
    //             DocumentServiceURL + "/Documents/AddTggingByKey",
    //             payload,
    //             ServiceName.DOCUMENTSERVICE
    //           ).then((data) => {
    //             console.log("File uploaded successfully!");
    //             setIsSuccess({isSuccess:true,message:`Appraisal has been ${btnEvent=='submit'? 'submitted':'saved'}`});

    //             return data;
    //           })
    //         });
    //     } catch (error) {
    //       setLoading(true);
    //       setIsError({isError:true,message:'Error uploading file'});
    //       console.error("Error uploading file: ", error);
    //     } finally{
    //       setFileMessage(false);
    //       wait(3000).then(() => {
    //         setIsSuccess({isSuccess:false,message:''});
    //         setIsError({isError:false,message:''});
    //         window.location.reload();
    //       })
    //     }

    //     console.log(data);
    //   });
    // });
    let observableBatch:any = [];
    var tempAttachments = [...attachments];


		for (let i = 0; i < tempAttachments.length; i++) {
      setFileMessage(true);
      const currentUtcDate = new Date(Date.parse(tempAttachments[i].lastModifiedDate.toUTCString()));
      var tempFilePayload = new UploadPreSignedPayloadModel();
      tempFilePayload.doctype = tempAttachments[i].doctype;
      tempFilePayload.fileAsBase64 = tempAttachments[i].fileAsBase64;
      tempFilePayload.fileName = tempAttachments[i].fileName;
      tempFilePayload.fileSize = tempAttachments[i].fileSize;
      tempFilePayload.fileType = tempAttachments[i].fileType;
      tempFilePayload.guid = firstLoadResults.appraisalData.appraisalId;
      tempFilePayload.lastModifiedBy = tempAttachments[i].lastModifiedBy;
      tempFilePayload.lastModifiedDate = currentUtcDate;
      tempFilePayload.lastModifiedTime = tempAttachments[i].lastModifiedTime;


			tempAttachments[i].guid = appraisalId;
			if (tempFilePayload.fileSize < 26000000) {
				observableBatch.push(postApiCall(DocumentServiceURL + "/Documents/add",tempFilePayload,ServiceName.DOCUMENTSERVICE));
			}
			else {

				largeFileCount.current++;
				await startFileChunkUpload(tempFilePayload);
			}
		}

		Promise.all(observableBatch).then(async data => {
			console.log("Direct upload document was saved Successfully", data);

			//this.docTypes = data;

			await waitForLargeFileToBeUploaded(btnEvent);

			//return data;

		},
			error => {

				console.log(error);
				return error;
			});
  };

  const startFileChunkUpload = async (file:any) => {

		fileSize.current = file.fileSize;

		const _totalCount = fileSize.current % chunkSize.current == 0 ? fileSize.current / chunkSize.current : Math.floor(fileSize.current / chunkSize.current) + 1; // Total count of chunks will have been upload to finish the file
		chunkCount.current = _totalCount;

		//let tmpDirectoryName = {tmpDirectoryName:file.guid};
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";

		chunkFile.tmpDirectory = file.guid;
		chunkFile.fileName = file.fileName;

		return await postApiCall(DocumentServiceURL + "/Documents/start",chunkFile,ServiceName.DOCUMENTSERVICE).then(async (data: any) => {
				console.log('success', data);
				uploadStartResponse.current = data;
				await fileUpload(file, uploadStartResponse.current);

				return uploadStartResponse.current;
			}
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}

  const fileUpload = async (file, uploadStartResponse) => {
		endOfTheChunk.current = chunkSize.current ;
		while (beginingOfTheChunk.current  <= file.fileAsBase64.length) {

			var chunk = file.fileAsBase64.slice(beginingOfTheChunk.current , endOfTheChunk.current );


			let chunkFile = new FileChunk();
			chunkFile.fileAsBase64 = chunk;
      const currentUtcDate = new Date(Date.parse(file.lastModifiedDate.toUTCString()));
			chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
			chunkFile.fileName = file.fileName;
			chunkFile.fileSize = file.size;
			chunkFile.lastModifiedTime = file.lastModifiedTime;
			chunkFile.lastModifiedDate = currentUtcDate;
			chunkFile['estUploadDate'] = file.estUploadDate;
			chunkFile.lastModifiedBy = file.lastModifiedBy;
			chunkFile.fileIndex = counter.current;

			let responseData = await uploadChunk(chunkFile);

			setCounter(counter.current  + 1);
			beginingOfTheChunk.current  = endOfTheChunk.current ;
			endOfTheChunk.current  = endOfTheChunk.current  + chunkSize.current ;

		}
		uploadCompleted(uploadStartResponse, file);

	}

  const uploadChunk = async (chunkFile: any): Promise<any> => {
		try {

			return await postApiCall(DocumentServiceURL + "/Documents/chunk",chunkFile,ServiceName.DOCUMENTSERVICE).then(
				(data:any) => {
					console.log('success', data);
					return true;
				},
				(error:any) => {
					console.error('error', error);
					return false;

				}
			);


		} catch (error) {

			console.log('error', error)
		}
	}


  const uploadCompleted = async (uploadStartResponse, file)  => {
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";
    const currentUtcDate = new Date(Date.parse(file.lastModifiedDate.toUTCString()));
		chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
		chunkFile.fileName = file.fileName;
		chunkFile.guid = file.guid;
		chunkFile.doctype = file.doctype;
		chunkFile.fileSize = file.fileSize;

		chunkFile.lastModifiedTime = file.lastModifiedTime;
		chunkFile.lastModifiedDate = currentUtcDate;
		chunkFile.lastModifiedBy = file.lastModifiedBy;


		return await postApiCall(DocumentServiceURL + "/Documents/end",chunkFile,ServiceName.DOCUMENTSERVICE).then( (data: any) => {
				console.log('success', data);
				let uploadEndResponse = data;
				largeFileSuccessCount.current++;
				return data;

			}
      // ,
			// error: (error: any) => {
			// 	console.error('error', error);
			// 	this.largeFileFailedCount++;
			// 	return error;

			// }
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}


  const waitForLargeFileToBeUploaded = async (btnEvent) => {
		while (largeFileCount.current != largeFileSuccessCount.current + largeFileFailedCount.current) {
			await wait(2000);
		}
		setIsSuccess({ isSuccess: true, message: `Appraisal has been ${btnEvent == 'submit' ? 'submitted' : 'saved'}` });
    wait(5000).then(() => {
          setFileMessage(false);
              setIsSuccess({ isSuccess: false, message: '' });
              setIsError({ isError: false, message: '' });
              window.location.reload();
            }); 
	}


  const addDataToDB = async (btnEvent: string,source:string = "") => {
    var appraisalObj = new AppraisalModel();

    appraisalObj.AppraisalId = firstLoadResults.appraisalData.appraisalId;
    appraisalObj.Xmin = firstLoadResults.appraisalData.xmin;

    if (btnEvent == "save") {
      appraisalObj.Status = firstLoadResults.appraisalData.status;
      appraisalObj.AppraisalRejected =
        firstLoadResults.appraisalData.appraisalRejected;
    }
    if (btnEvent == "submit") {
      appraisalObj.Status = "Submit";
      appraisalObj.AppraisalRejected = false;
    }

    if (btnEvent == "delete") {
      appraisalObj.Status = firstLoadResults.appraisalData.status;
      appraisalObj.AppraisalRejected = false;
      appraisalObj.IsDeleted = true;
    }
    appraisalObj.InvestmentId = firstLoadResults.appraisalData.investmentId;
    appraisalObj.AppraisalType = appraisalType;
    var appraiser1FirstName =
      selectedAppraiser1?.firstName != null
        ? selectedAppraiser1?.firstName
        : "";
    var appraiser1LastName =
      selectedAppraiser1?.lastName != null ? selectedAppraiser1?.lastName : "";
    var appraiser1email =
      selectedAppraiser1?.email != null ? selectedAppraiser1?.email : "";
    appraisalObj.Appraiser1 = {
      firstName: appraiser1FirstName,
      lastName: appraiser1LastName,
      email: appraiser1email,
    };
    appraisalObj.Appraiser2 = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.Appraiser3 = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.Fiduciary = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.AppraiserFirm = selectedAppraisalFirm.label;
    appraisalObj.AssetManager = {
      ...firstLoadResults.appraisalData.assetManager,
    };
    appraisalObj.City = firstLoadResults.appraisalData.city;
    appraisalObj.State = firstLoadResults.appraisalData.state;
    appraisalObj.Country = firstLoadResults.appraisalData.country;
    appraisalObj.ExternalAppraiser = selectedExternalAppraiser;
    appraisalObj.Fund = firstLoadResults.appraisalData.fund;
    appraisalObj.FundId = firstLoadResults.appraisalData.fundId;
    appraisalObj.HasDebtLiability =
      firstLoadResults.appraisalData.hasDebtLiability;
    appraisalObj.InvestmentName = firstLoadResults.appraisalData.investmentName;
    appraisalObj.WorkflowId = firstLoadResults.appraisalData.workflowId;
    appraisalObj.WorkflowSteps = firstLoadResults.appraisalData.workflowSteps;
    appraisalObj.AssetManagerHead =
      firstLoadResults.appraisalData.assetManagerHead;
    appraisalObj.InvestmentPropertyType =
      firstLoadResults.appraisalData.investmentPropertyType;
    appraisalObj.InvestmentType = firstLoadResults.appraisalData.investmentType;
    appraisalObj.PortfolioManager =
      firstLoadResults.appraisalData.portfolioManager;
    appraisalObj.SectorHead = firstLoadResults.appraisalData.sectorHead;
    appraisalObj.CreatedBy = firstLoadResults.appraisalData.createdBy;
    appraisalObj.CanSubmit = firstLoadResults.appraisalData.canSubmit;
    appraisalObj.Frequency = frequency;

    appraisalObj.Currency = appraisalDetailsForDLorDARDX.currencySelected;
    appraisalObj.CurrentAppraisalValue =
      appraisalDetailsForDLorDARDX.currentDebtValue;
      appraisalObj.currentPrincipalValue = appraisalDetailsForDLorDARDX.currentPrincipalValue;
      appraisalObj.loanToValueRatio = appraisalDetailsForDLorDARDX.loanToValueRatio != null ? Number(appraisalDetailsForDLorDARDX.loanToValueRatio?.toString().replaceAll(",","")).toFixed(2) : null ;
      appraisalObj.treasuryRate = appraisalDetailsForDLorDARDX.treasuryRate != null ? Number(appraisalDetailsForDLorDARDX.treasuryRate?.toString().replaceAll(",","")).toFixed(2) : null ;
      appraisalObj.riskPremium = appraisalDetailsForDLorDARDX.riskPremium != null ? Number(appraisalDetailsForDLorDARDX.riskPremium?.toString().replaceAll(",","")).toFixed(2) : null ;
      appraisalObj.surveyYield = appraisalDetailsForDLorDARDX.surveyYield != null ? Number(appraisalDetailsForDLorDARDX.surveyYield?.toString().replaceAll(",","")).toFixed(2) : null ;
    appraisalObj.ValueDate = //new Date(
      appraisalDetailsForDLorDARDX.currentEffectiveDate
    //);
    appraisalObj.Derivative = Number(appraisalDetailsForDLorDARDX.derivative?.toString().replaceAll(",",""));
    appraisalObj.LastAppraisedValue =
      appraisalDetailsForDLorDARDX.lastDebtValue;
    appraisalObj.LastAppraisalDate =
      appraisalDetailsForDLorDARDX.lastDebtEffectiveDate;

      appraisalObj.PercentageChange =  appraisalDetailsForDLorDA.lastDebtPercentageChange != "Infinity" && appraisalDetailsForDLorDA.lastDebtPercentageChange != "NaN" ?
        appraisalDetailsForDLorDA.lastDebtPercentageChange : null;

      appraisalObj.Assets = [] as AppraisalAssetsModel [];

      // if(firstLoadResults.appraisalData.status === "Posted"){
      //   appraisalObj.ActiveIndex = activeIndex;
      // }

    try {
      setLoading(true);
      await postApiCall(
        AppraisalReviewServiceURL + "/appraisals/" + btnEvent,
        appraisalObj,
        ServiceName.APPRAISALREVIEW
      ).then(async (data: any) => {
        console.log(data.result);

        if (btnEvent == "save") {
          setAppraisalDataAfterSave({
            appraisalId: data.result.id,
            xmin: data.result.xmin,
          });
          await submitAttachment(data.result.id,btnEvent);
          if(source == "POSTEDIT"){
            await addTaskDataToDB();
          }
        } else if (btnEvent == "submit") {
          await submitAttachment(data.result,btnEvent);
        } else if (btnEvent == "delete") {
          try {
            await getApiCall(
              InvestmentServiceURL +
                "/investments/updateinvestmentassets?InvestmentId=" +
                firstLoadResults.appraisalData.investmentId,
              ServiceName.INVESTMENTSERVICE
            ).then((res: any) => console.log(res));

            await terminateWorkflow(data.result);
            setIsSuccess({
              isSuccess: true,
              message: "Appraisal has been deleted",
            });
          } catch (e: any) {
          } finally {
            
            wait(3000).then(() => {
              setIsSuccess({ isSuccess: false, message: "" });
              navigate("/main/dashboard");
            });
          }
        }
        if(attachments.length === 0){
          setIsSuccess({isSuccess:true,message:`Appraisal has been ${btnEvent=='submit'? 'submitted':'saved'}`});
          window.location.reload();
        }      });
    } catch (error:any) {
      console.log(error?.response.data.responseException.exceptionMessage);
      setIsError({isError:true,message:`Appraisal can not be ${btnEvent=='submit'? 'Submitted':'Saved'}. ${error?.response.data.responseException.exceptionMessage}`});
    } finally {
        setLoading(false);
        
      if (btnEvent == "submit") {
        dispatch(updateappraisalSubmitEvent(false));
        wait(3000).then(() => {
          setIsSuccess({isSuccess:false,message:""});
        setIsError({isError:false,message:''});
          navigate("/main/dashboard");
        });
      }else{
        wait(3000).then(() =>{
          setIsSuccess({isSuccess:false,message:""});
        setIsError({isError:false,message:''});
        });
      }
    }
  };

  const terminateWorkflow = async (data: any) => {
    try {
      data.forEach(async (element: any) => {
        var deleteAppraisalTaskItem = new AppraisalTask();
        deleteAppraisalTaskItem.appraisalid = element.appraisalId;
        deleteAppraisalTaskItem.workflowId = element.workflowId;
        deleteAppraisalTaskItem.approver = userContext.displayName;
        deleteAppraisalTaskItem.firstname = userContext.firstName;
        deleteAppraisalTaskItem.lastname = userContext.lastName;
        deleteAppraisalTaskItem.approverEmail = userContext.email;
        deleteAppraisalTaskItem.comments = "";

        await postApiCall(
          TaskmgmtServiceURL + "/Workflows/Terminate",
          deleteAppraisalTaskItem,
          ServiceName.TASKMANAGEMENTSERVICE
        )
          .then((data: any) => {
            console.log(data);
          })
          .catch((e: any) => {
            console.log(e);
          });
      });
    } catch (e) {
    } finally {
      setIsSuccess({
        isSuccess: true,
        message: "Appraisal has been deleted",
      });
      wait(3000).then(() => {
        setIsSuccess({ isSuccess: false, message: "" });
      });
    }
  };
  const onSave = (source:string = "") => {
    setIsSaveClicked(true);

    addDataToDB("save",source);
    // } else {
    //   setIsError({ isError: true, message: "Please Clear Validation Errors" });
    //   wait(3000).then(() => {
    //     setIsError({ isError: false, message: "" });
    //   });
    // }
    console.log("selectedInvestment", selectedInvestment);
  };

  function appraisalValuesValidator() {
    var flag = false;

    flag = appraisalDetailsForDLorDARDX.currentDebtValue != null && appraisalDetailsForDLorDARDX.currentDebtValue != "" && appraisalDetailsForDLorDARDX.currentPrincipalValue != null && appraisalDetailsForDLorDARDX.currentPrincipalValue != "" &&
      ((appraisalDetailsForDLorDARDX.currentEffectiveDate != "") as boolean);

    return flag;
  }

  function AssetSumValidator() {
    var flag = false;
    var sum: number = 0;
    if (modifiedAsset.length > 0) {
      modifiedAsset.forEach((asset: AppraisalAssetsModel) => {
        if(asset.currentAppraisalValue != null)
        sum += Number(asset.currentAppraisalValue.toString().replace(/,/g,""));

      });
    }
    flag = Number(appraisalsDetailsRDX.currentAppraisalValue?.toString().replace(/,/g,"")) === sum;

    return flag;
  }

  function investmentDetailValidator() {
    var flag = false;
    flag =
      selectedAppraisalFirm.label != "" &&
      selectedAppraiser1?.email != "" &&  selectedAppraiser1?.email != undefined &&
      selectedExternalAppraiser != "";

    return flag;
  }

  const appraisalValidator = () => {
    var flag: boolean = false;

    var assetManager = false;
    var invType = false;
    var fund = false;
    var cityState = false;

    var appraisalStatus: string =
      firstLoadResults.appraisalData.status.toLowerCase();
    if (appraisalStatus === "new" && appraisalStatus.indexOf("reject") == -1) {
      if (firstLoadResults.appraisalData.assetManager != null) {
        if (
          firstLoadResults.appraisalData.assetManager.email.toLowerCase() !=
          "not.applicable@maskedqicaait.org"
        ) {
          assetManager = true;
        }
      }
    }
    if (firstLoadResults.appraisalData.assetManager != null) {
      if (
        firstLoadResults.appraisalData.assetManager.email.toLowerCase() !=
        "not.applicable@maskedqicaait.org"
      ) {
        assetManager = true;
      }
    }

    if (
      firstLoadResults.appraisalData.investmentType != "" ||
      firstLoadResults.appraisalData.investmentType != null
    ) {
      invType = true;
    }

    if (cityStateCountry != "") {
      cityState = true;
    }
    if (
      firstLoadResults.appraisalData.fundId != "" ||
      firstLoadResults.appraisalData.fund != "" ||
      firstLoadResults.appraisalData.fundId != null ||
      firstLoadResults.appraisalData.fund != null
    ) {
      fund = true;
    }
    flag = assetManager && invType && fund && cityState;
    return flag;
  };
  const onSubmit = () => {
    var isAppraisalValuesValid = appraisalValuesValidator();
    // var assetValidator = modifiedAsset.length > 0 && firstLoadResults.appraisalData.investmentType.toLowerCase() != "Debt Liability"  ? AssetSumValidator() : true;
    var isInvestmentDetailValid = investmentDetailValidator();
    var isAppraisalValid = appraisalValidator();
    dispatch(updateappraisalSubmitEvent(true));

    if (
      !isAppraisalValuesValid &&
      // !assetValidator &&
      !isInvestmentDetailValid &&
      !isAppraisalValid
    ) {
      setIsError({
        isError: true,
        message:
          "Please correct the validation errors."// and The sum of the asset-level values does not equal the investment value. Please reconcile.",
      });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    } else if (
      !isAppraisalValuesValid ||
      !isInvestmentDetailValid ||
      !isAppraisalValid
    ) {
      setIsError({
        isError: true,
        message: "Please correct the validation errors.",
      });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    } 
    // else if (!assetValidator) {
    //   setIsError({
    //     isError: true,
    //     message:
    //       "The sum of the asset-level values does not equal the investment value. Please reconcile.",
    //   });
    //   wait(3000).then(() => {
    //     setIsError({ isError: false, message: "" });
    //   });
    // }

    if (isAppraisalValuesValid && isInvestmentDetailValid){//} && assetValidator) {
      addDataToDB("submit");
    }
    // console.log(assetValidator);
    console.log(isAppraisalValuesValid);

    dispatch(updateappraisalSubmitEvent(true));
    console.log(selectedAppraisalFirm);
    console.log(selectedAppraiser1);
  };

  const CanSubmit = (appraisalData: GetAppraisalModel) => {
    if (
      appraisalData.canSubmit &&
      (appraisalData.status == "New" ||
        appraisalData.appraisalRejected ||
        appraisalData.status == "Revoked")
    ) {
      setCanSubmit(
        (userContext.isAppraisal1 && appraisalData.appraisalType != "DL") ||
          (userContext.isDebtAppraisal1 &&
            (appraisalData.appraisalType == "DL" ||
              appraisalData.appraisalType == "DL Interim")) ||
          (userContext.isDebtAppraisal1 &&
            appraisalData.appraisalType == "DA") ||
          userContext.isAdmin ||
          appraisalData.appraisalRejected
          ? true
          : false
      );
    }

    // (this.currentUserContext.isAppraisal1 && this.newAppraisalItem.appraisalType != "DL") || (this.currentUserContext.isDebtAppraisal1 && (this.newAppraisalItem.appraisalType == "DL" || this.newAppraisalItem.appraisalType == "DL Interim")) || (this.currentUserContext.isDebtAppraisal1 && this.newAppraisalItem.appraisalType == "DA") || this.currentUserContext.isAdmin || this.newAppraisalItem.appraisalRejected) ? true : false
  };

  const getLastAppraisalByInvIdAndInvType = (lastAppraisalString: string) => {
    console.log(lastAppraisalString);

    const baseUrl = window.location.origin;
    console.log(baseUrl);
    if (
      InvestmentIdAndAppraisalId.investmentId == "" ||
      InvestmentIdAndAppraisalId.appraisalId == ""
    ) {
      if (lastAppraisalString == "GetLastPostedAppraisalIdByInv")
        setOpenModel({
          isOpen: true,
          message:
            "Last Appraisal value for the selected investment does not exist",
        });
      if (lastAppraisalString == "GetLastAnnualPostedAprslByInv")
        setOpenModel({
          isOpen: true,
          message:
            "Last Annual Appraisal value for the selected investment does not exist",
        });
    } else {
      try {
        setLoading(true);
        var call:any = null;
        if (InvestmentIdAndAppraisalId.appraisalId == "") {
          call = getApiCall(
            AppraisalReviewServiceURL +
              "/appraisals/" +
              lastAppraisalString +
              "?inv=" +
              InvestmentIdAndAppraisalId.investmentId,
            ServiceName.APPRAISALREVIEW
          );
        } else {
          call = getApiCall(
            AppraisalReviewServiceURL +
              "/appraisals/" +
              lastAppraisalString +
              "?inv=" +
              InvestmentIdAndAppraisalId.investmentId +
              "&id=" +
              InvestmentIdAndAppraisalId.appraisalId,
            ServiceName.APPRAISALREVIEW
          );
        }
        if (call != null) {
          call
            .then((data: any) => {
              if (data.result.length > 0) {
                const id = data.result;
                const baseUrl = window.location.origin;
                const url = baseUrl + "/main/debt-liability/view/" + id;
                window.open(url, "_blank");
              } else {
                if (lastAppraisalString == "GetLastPostedAppraisalIdByInv")
                  setOpenModel({
                    isOpen: true,
                    message:
                      "Last Appraisal value for the selected investment does not exist",
                  });
                if (lastAppraisalString == "GetLastAnnualPostedAprslByInv")
                  setOpenModel({
                    isOpen: true,
                    message:
                      "Last Annual Appraisal value for the selected investment does not exist",
                  });
              }
            })
            .catch((e: any) => {
              console.log(e);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      } catch (e: any) {
        console.log(e);
      }
    }
    // setOpenModel({isOpen:true,message:"Hello"});
  };

  const deleteAppraisal = () => {
    if (firstLoadResults.appraisalData.status.toLowerCase() != "posted") {
      addDataToDB("delete");
    }
  };

  const handleClose = () => {
    setOpenRevokeDialog(false);
  };

  const checkExistingPendingAppraisals = async (
    invType: string,
    invId: string
  ) => {
    var flag: boolean = false;
    await getApiCall(
      AppraisalReviewServiceURL +
      "/appraisals/GetPendingAppraisalByInvestment?investmentId=" +
      invId +
      "&investmentType=" +
      invType,
      ServiceName.APPRAISALREVIEW
    ).then((data: any) => {
      var pendingCount: number = data.result.length;
      if (pendingCount > 0) {
        flag = true;
      }
    });
    return flag;
  };
  const revokeappraisal = async () => {
    if (revokeComments != "") {
      var revokeRequest = new AppraisalRevokedRequest();

      revokeRequest.Id = appraisalId != undefined ? appraisalId : "";
      revokeRequest.UerEmail = userContext.email;
      revokeRequest.Comments = revokeComments;
      var flag = await checkExistingPendingAppraisals(firstLoadResults.appraisalData.investmentType,firstLoadResults.appraisalData.investmentId)
      if(!flag){
        try {
          postApiCall(
            AppraisalReviewServiceURL + "/appraisals/RevokeAppraisal",
            revokeRequest,
            ServiceName.APPRAISALREVIEW
          )
            .then((data: any) => {
              if (data.message === "POST Request successful.") {
                setIsSuccess({
                  isSuccess: true,
                  message: "Appraisal has been Revoked",
                });
                wait(3000).then(() => {
                  setIsSuccess({ isSuccess: false, message: "" });
                  navigate("/main/dashboard");
                });
              }
            })
            .catch((e: any) => {
              setIsError({
                isError: true,
                message: "Appraisal could not be revoked",
              });
              wait(3000).then(() => {
                setIsError({ isError: false, message: "" });
              });
            });
        } catch (e) {
          console.log(e);
        }
      }else{
        handleClose();
        setIsError({ isError: true, message: "Could Not be revoked as there are some pending appraisal for this investment." });
      }
    } else {
      setIsError({
        isError: true,
        message: "Please Add the comments for Appraisal to be Revoked",
      });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    }
  };
  const handleEditToggle = () => {
    setAppraisalTypeEditable(!appraisalTypeEditable);
  }


  const handlePostEditConfirm = () => {
    if (postEditComments == "") {
      setIsError({ isError: true, message: "You can not save posted appraisal without comments" });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    } else {
      onSave("POSTEDIT");
    }
  };

  const addTaskDataToDB = async () => {
    var taskObj = new AppraisalTask();
    taskObj.taskComments = postEditComments;
    taskObj.appraisalStatus = firstLoadResults.appraisalData.status;
    taskObj.previousStatus = firstLoadResults.appraisalData.status;
    taskObj.appraisalid = firstLoadResults.appraisalData.appraisalId;
    taskObj.workflowId = firstLoadResults.appraisalData.workflowId;
    taskObj.approver = userContext.displayName;
    taskObj.firstname = userContext.firstName;
    taskObj.lastname = userContext.lastName;
    taskObj.approverEmail = userContext.email;
    taskObj.status = "Posted (Edited by Admin)";
    taskObj.approverName = userContext.firstName + ' ' + userContext.lastName;

    await postApiCall(
      TaskmgmtServiceURL + "/AuditTasks/AddAuditLog",
      taskObj, ServiceName.TASKMANAGEMENTSERVICE
    )
      .then((data: any) => {
        setIsSuccess({
          isSuccess: true,
          message: "Audit Log successfully created !"
        });
        wait(2000).then(() => {
          setIsSuccess({ isSuccess: false, message: "" });
        });
      })
      .catch((e: any) => {
        setIsError({
          isError: true,
          message: "Audit Log could not be created",
        });
        wait(2000).then(() => {
          setIsError({ isError: false, message: "" });
        });
      });
  };

  const onSaveClicked = () => {
    if(userContext.admin && firstLoadResults.appraisalData.status === "Posted") {
      setOpenPostEdit(true);
    } else{
      onSave();
    } 
  }
  const handlePostEditClose = () => {
    setOpenPostEdit(false);
  };

  return (
    <>
      <Modal
        open={openModel.isOpen}
        onClose={() => {
          setOpenModel({ isOpen: false, message: "" });
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <WarningIcon /> Notification
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {openModel.message}
          </Typography>
        </Box>
      </Modal>
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
      {assetManagerInvalid.flag && (
        <ToastMessage message={assetManagerInvalid.message} severity="error" />
      )}
      {/* Revoke Dialog */}
      <Dialog open={openRevokeDialog} onClose={handleClose}>
        <DialogTitle>Enter Comments *</DialogTitle>
        <DialogContent>
          <TextareaAutosizee
            required
            sx={{
              '& .MuiInputLabel-asterisk' : {
                color:'red',
              },}
            }
            value={revokeComments}
            autoFocus
            id="comment"
            aria-label="empty textarea"
            placeholder="Enter Comments Here..."
            minRows={7}
            onChange={(e: any) => setRevokeComments(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{textTransform:"none"}} onClick={revokeappraisal} color="primary">
            Confirm
          </Button>
          <Button sx={{textTransform:"none"}} onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/*  END Revoke Dialog*/}

      {/* Posted edit comment dialog */}
      <Dialog open={openPostEdit} onClose={handlePostEditClose}>
        <DialogTitle>
          Enter Comments <span style={{color:'red'}}>*</span>
        </DialogTitle>
        <DialogContent>
          <TextareaAutosize
            value={postEditComments}
            autoFocus
            id="comment"
            aria-label="empty textarea"
            placeholder="Enter Comments Here..."
            minRows={7}
            onChange={(e) => setPostEditComments(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{textTransform:"none"}} onClick={handlePostEditConfirm} color="primary">
            Save
          </Button>
          <Button sx={{textTransform:"none"}} onClick={handlePostEditClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* END Posted edit comment dialog */}

      <div className="form-wrap">
        <Box sx={{ width: "100%", typography: "body1" }}>
          {loading && (
            <div className="overlaySpinner">
              <CircularProgress />
            </div>
          )}
          {fileMessage && (
            <div className="overlaySpinner">
              { fileMessage  && <><span>File upload is in progress... &nbsp;  </span>
              <CircularProgress /></> }
            </div>
          )}
          <Grid container spacing={3}>
            <Grid item xs>
            </Grid>
            <Grid item xs={6}>
              <HorizontalStepper workflowSteps = {workflowSteps} activeIndex={activeIndex}/>
            </Grid>
            <Grid item xs>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6}>
            <Box display="flex" paddingBottom={2} alignItems="center" gap={2}>  
              <InputLabel><><h3 className="heading2">Appraisal Type :</h3></></InputLabel>
              <Select
                size='medium'
                variant='standard'
                sx={{ m: 1, minWidth: 80 }}
                value={appraisalType}
                onChange={(e) => setAppraisalType(e.target.value)}
                readOnly={!appraisalTypeEditable}
                inputRef={selectRef}
              >
                {appraisalTypeArray.map((value: string, index: number) => {
                  return <MenuItem value={value}>{value}</MenuItem>
                })}
              </Select>
              {appraisalTypeEditFlag && <Button sx={{ textTransform: "none", ml: 2 }} variant="text" onClick={() => handleEditToggle()}>{appraisalTypeEditable? 'Save' : 'Edit'}</Button>}
              </Box>
            </Grid>
            <Grid item xs={6} sm={6} className="HamburgerActionButtons">
            <AuditButton />
              {/* <Grid container spacing={2}>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}>
                  <Grid container spacing={2}>
                    <Grid item xs={2} sm={2}></Grid>
                    <Grid item xs={2} sm={2}></Grid>
                    <Grid item xs={2} sm={3}>
                      <Button sx={{textTransform:"none"}}
                        variant="outlined"
                        size="medium"
                        style={{ marginTop: 20 }}
                        color="success"
                      >
                        Audit
                      </Button>
                    </Grid>
                    <Grid item xs={2} sm={2}> */}
                      <HamburgerMenu
                        appraisalId={appraisalId}
                        loading={setLoading}
                        userContext={userContext}
                        workflowId={firstLoadResults.appraisalData.workflowId}
                        openRevokeDialog={setOpenRevokeDialog}
                        deleteAppraisal={deleteAppraisal}
                        isSuccess={setIsSuccess}
                        isError={setIsError}
                      />
                    {/* </Grid>
                  </Grid>
                </Grid>
              </Grid> */}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6}>
              {/* {!appraisalTypeEditClicked && <><h3 className="heading">Appraisal Type : {appraisalType} <span>{appraisalTypeEditFlag &&
                <Button sx={{textTransform:"none",ml: 2}} variant="text" onClick={() => setAppraisalTypeEditClicked(true)} size="small" >Edit</Button>}</span></h3></>
              }
              {appraisalTypeEditClicked &&
                <ClickAwayListener onClickAway={() => setAppraisalTypeEditClicked(false)}>
                  <TextField
                    label="AppraisalType"
                    value={appraisalType}
                    variant="outlined"
                    size="small"
                    onChange={(e) => setAppraisalType(e.target.value)}
                  />
                </ClickAwayListener>} */}
            </Grid>
            <Grid item xs={6} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}>
                  {firstLoadResults.appraisalData.hasDebtLiability && (
                    <Alert
                      severity="info"
                      sx={{
                        justifyContent: "center",
                        marginBottom: 2,
                        padding: 0,
                      }}
                    >
                      {"Debt Liability Associated"}
                    </Alert>
                  )}{" "}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6}>
              <TextField
                required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                label="Investment"
                value={
                  firstLoadResults.appraisalData.investmentId +
                  " - " +
                  firstLoadResults.appraisalData.investmentName
                }
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <TextField
                required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                label="Fund"
                value={
                  firstLoadResults.appraisalData.fundId +
                  " : " +
                  firstLoadResults.appraisalData.fund
                }
                variant="outlined"
                size="small"
                fullWidth
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                InputProps={{
                  readOnly: true,
                }}
                label="Asset Manager"
                value={
                  firstLoadResults.appraisalData.assetManager != null
                    ? firstLoadResults.appraisalData.assetManager?.firstName +
                      ", " +
                      firstLoadResults.appraisalData.assetManager?.lastName
                    : ""
                }
                variant="outlined"
                size="small"
                error={
                  isSubmit &&
                  firstLoadResults.appraisalData.assetManager === null
                }
                fullWidth
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                label="City/State/Country"
                value={cityStateCountry}
                variant="outlined"
                fullWidth
                size="small"
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Autocomplete
                clearIcon={null}
                id="appraiser-1"
                options={appraiser1List || []}
                getOptionLabel={(option) => {
                  return option.firstName + " " + option.lastName;
                }}
                sx={{
                  '& .MuiInputLabel-asterisk' : {
                    color:'red',
                  },}
                }
                readOnly={flagToDisableControlesForAppraisal}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.firstName} {option.lastName}
                    {option.userType === "Internal" ? (
                      <Badge
                        color="success"
                        sx={{ paddingLeft: "40px" }}
                        badgeContent={option.userType}
                      ></Badge>
                    ) : (
                      <Badge
                        color="warning"
                        sx={{ paddingLeft: "40px" }}
                        badgeContent={option.userType}
                      ></Badge>
                    )}
                  </Box>
                )}
                value={selectedAppraiser1}
                onChange={(event, value) =>
                  handleAppraiser1Change(
                    value as unknown as {
                      firstName: string;
                      lastName: string;
                      email: string;
                      name: string;
                      userType: string;
                    }
                  )
                }
                // sx={{ width: 400 }}
                
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label={
                      "Appraiser 1 " +
                      `{ ${selectedAppraiser1?.userType != undefined ?selectedAppraiser1?.userType : ''}  User }`
                    }
                    size="small"
                    error={(selectedAppraiser1?.email === "" || selectedAppraiser1?.email == undefined) && isSubmit}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                }}
                required
                label="Investment Type"
                value={firstLoadResults.appraisalData?.investmentType}
                variant="outlined"
                fullWidth
                size="small"
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Autocomplete
                clearIcon={null}
                id="Appraisal-Firm"
                value={selectedAppraisalFirm}
                getOptionLabel={(option) => {
                  return option.label;
                }}
                readOnly={flagToDisableControlesForAppraisal}
                options={appraisalFirms}
                // sx={{ width: 400 }}
                sx={{
                  '& .MuiInputLabel-asterisk' : {
                    color:'red',
                  },}
                }
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label="Appraisal Firm"
                    size="small"
                    error={selectedAppraisalFirm.label === "" && isSubmit}
                  />
                )}
                onChange={(event, value) => {
                  handleFirmChangeChange(
                    value as unknown as { label: string; value: string }
                  );
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Autocomplete
                clearIcon={null}
                id="External-Appraiser"
                options={externalAppraiserArray}
                value={selectedExternalAppraiser}
                onChange={(e, value) => {
                  handleExternalAppraiserChange(value as string);
                }}
                readOnly={flagToDisableControlesForAppraisal}
                // sx={{ width: 400 }}
                sx={{
                  '& .MuiInputLabel-asterisk' : {
                    color:'red',
                  },}
                }
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label="External Appraiser"
                    size="small"
                    error={!selectedExternalAppraiser && isSubmit}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
        <Divider className="divider-line"></Divider>
        <Box
          sx={{ width: "100%", typography: "body1" }}
          className="accordion-wrap"
        >
          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography>Appraisal Value</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <AppraisalValueTableForDLorDA
                flagToDisableControlesForAppraisal={
                  flagToDisableControlesForAppraisal
                }
                postEditForAdmin = {userContext.isAdmin && firstLoadResults.appraisalData.status == "Posted" }
                openLastAppraisalValue={getLastAppraisalByInvIdAndInvType}
                countriesData={allCountries.current}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
            >
              <Typography>Documents</Typography>
            </AccordionSummary>
            <AccordionDetails className="upload-document">
              {documentTypes.length != 0 && (
                <ViewTabList
                isValuationTypeRequired = {false}
                  tabData={documentTypes}
                  appraisalType={appraisalType}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box sx={{ padding: "15px 2px" }}>
          <Grid item xs={12}>
            <Button sx={{textTransform:"none"}}
              onClick={onSaveClicked}
              variant="contained"
              size="medium"
              color="success"
              disabled={
                (firstLoadResults.appraisalData.status !== "New" &&
                  firstLoadResults.appraisalData.status !== "Posted" &&
                  firstLoadResults.appraisalData.status !== "Revoked" &&
                  !firstLoadResults.appraisalData.appraisalRejected) ||
                (firstLoadResults.appraisalData.status === "Posted" &&
                  !userContext?.isAdmin)
              }
            >
              Save
            </Button>
            <Button sx={{textTransform:"none",ml: 2}}
              variant="outlined"
              size="medium"
              color="error"
              onClick={()=>navigate("/main/dashboard")}
            >
              Close
            </Button>
            <Button sx={{textTransform:"none"}}
              variant="contained"
              size="medium"
              color="primary"
              className="text-right"
              onClick={onSubmit}
              disabled={
                !canSubmit ||
                !(
                  firstLoadResults.appraisalData.status == "New" ||
                  firstLoadResults.appraisalData.status == "Revoked" ||
                  firstLoadResults.appraisalData.status ==
                    "Pending for Appraiser 1 Review" ||
                  firstLoadResults.appraisalData.appraisalRejected
                )
              }
            >
              Submit
            </Button>
          </Grid>
        </Box>
      </div>
    </>
  );
};
